import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Tooltip, useDisclosure } from '@chakra-ui/react'
import { AgGridReact } from 'ag-grid-react'
import AssetsActionsRowRenderer from '../../../../views/catalogue/AssetList/components/AssetsActionsRowRenderer'
import AssetViewer from '../../../assets/assetViewer'
import AddNewAssetButton from '../../../assets/addNewAssetButton'

const SiteAssetsDetail = (props: any) => {


    const [selectedAsset, setSelectedAsset] = useState<number>();
    const { isOpen, onOpen, onClose } = useDisclosure()

    const handleOnSelectAsset = (assetId: number) => {


        if (assetId) {
            setSelectedAsset(assetId);
            onOpen();
        }
        else {
            setSelectedAsset(undefined)
        }
    }

    const colDefs = [
        { headerName: "Name", field: "name", flex: 2 },
        { headerName: "Type", field: "type" },
        { headerName: "Model", field: "model" },
        { headerName: "Manufacturer", field: "manufacturer" },
        {
            headerName: "Actions", field: "assetId", cellRenderer: AssetsActionsRowRenderer, cellRendererParams: {
                openAssetDialog: handleOnSelectAsset
            }
        }
    ];




    return (
        <>

            <Card>
                {/* <Tooltip label={"Add Asset"}>
                    <Button colorScheme='brand'  size={"xs" } variant={"outline"} width={150} marginBottom='2' >
                        Add New Asset
                    </Button>
                </Tooltip> */}

             <AddNewAssetButton/>

                <div
                    className="ag-theme-quartz" // applying the grid theme
                    style={{ height: 350 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        rowData={props.AssetStore.siteAssets}
                        pagination
                        columnDefs={colDefs}
                        paginationAutoPageSize
                    />

                </div>
            </Card>

            <Modal size={'xl'} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent >
                    <ModalHeader>Asset Detail</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <AssetViewer assetId={selectedAsset} />
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal></>
    )
}

SiteAssetsDetail.propTypes = {
    AssetStore: PropTypes.any,
}

export default SiteAssetsDetail